if (!customElements.get('gift-order-option')) {
  class GiftOrderOption extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.checkbox = this.querySelector('[data-js-gift-order]');
      this.status = this.querySelector('[data-js-gift-order-status]');
      this.savedValue = this.checkbox?.checked ? 'Yes' : '';
      this.pendingValue = this.savedValue;
      this.saving = false;

      if (!this.checkbox) return;
      this.checkbox.addEventListener('change', () => {
        this.pendingValue = this.checkbox.checked ? 'Yes' : '';
        this.processQueue();
      });
    }

    async processQueue() {
      if (this.saving) return;

      this.saving = true;
      this.setAttribute('aria-busy', 'true');

      while (this.savedValue !== this.pendingValue) {
        const value = this.pendingValue;
        const saved = await this.savePreference(value);

        if (!saved) {
          if (this.pendingValue === value) {
            this.checkbox.checked = this.savedValue === 'Yes';
            if (this.status) this.status.textContent = this.dataset.errorMessage;
          }
          break;
        }

        this.savedValue = value;
        if (this.pendingValue === value && this.status) {
          this.status.textContent = value
            ? this.dataset.savedMessage
            : this.dataset.removedMessage;
        }
      }

      this.saving = false;
      this.removeAttribute('aria-busy');
    }

    async savePreference(value) {
      const root = window.Shopify?.routes?.root || '/';
      const formData = new FormData();

      formData.append('attributes[Gift order]', value);

      try {
        const response = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          body: formData,
        });

        if (!response.ok && !(await this.preferenceMatchesCart(root, value))) {
          throw new Error('Unable to save gift preference');
        }
        return true;
      } catch (error) {
        return false;
      }
    }

    async preferenceMatchesCart(root, value) {
      try {
        const response = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return false;

        const cart = await response.json();
        return (cart.attributes?.['Gift order'] || '') === value;
      } catch (error) {
        return false;
      }
    }
  }

  customElements.define('gift-order-option', GiftOrderOption);
}
